/**
* @components 选择国家
* @author 陈
* @param {function} handleConfirm
*/

<template>
  <div class="AreaSelect-container">
    <van-popup
      position="bottom"
      v-model="visible"
      :closeable="false"
      :close-on-click-overlay="false"
    >
      <van-picker
        title="选择国家/地区"
        show-toolbar
        :columns="area"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>
<script>
import { postSignup, SendSms } from "@/apis/league";
import globalDialog from "@/mixins/globalDialog";
import areaOrigin from "@/utils/area";
import { deepClone } from "@/utils";

export default {
  data() {
    return {
      area: [],
      areaOrigin: [],
      visible: false,
    };
  },
  methods: {
    onConfirm(value, index) {
      this.$emit("onConfirm", {
        label: value,
        value: this.areaOrigin[index].country_code,
      });
      this.visible = false;
    },
    onCancel() {
      this.visible = false;
    },
  },
  mounted() {
    let newArea = deepClone(areaOrigin),
      areaList = [];
    newArea.forEach((item, index) => {
      areaList.push(`${item.country_name_cn}+${item.country_code}`);
    });
    this.area = areaList;
    this.areaOrigin = deepClone(areaOrigin);
  },
};
</script>
<style lang='scss' scope>
</style>



// WEBPACK FOOTER //
// src/components/AreaSelect/index.vue